import type { AiModelEnum, Annotation, EvidenceSessionAIModel } from 'api';
import { useRef } from 'react';

import { useCanvasRendering } from './useCanvasRendering';
import { useDesktopZoom } from './useDesktopZoom';
import { useTouchHandlers } from './useTouchHandlers';

interface UseSegmentationOverlayProps {
  imageSrc: string;
  annotations: Annotation[];
  hiddenCategories: string[];
  model: AiModelEnum | EvidenceSessionAIModel;
  showLegend: boolean;
  isMobile: boolean;
}

export const useSegmentationOverlay = ({
  imageSrc,
  annotations,
  hiddenCategories,
  model,
  showLegend,
  isMobile,
}: UseSegmentationOverlayProps) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const desktopZoom = useDesktopZoom({ canvasRef, isMobile });
  const touchHandlers = useTouchHandlers({ canvasRef, isMobile });
  const canvasRendering = useCanvasRendering({
    annotations,
    canvasRef,
    hiddenCategories,
    imageSrc,
    isMobile,
    mobileZoom: touchHandlers.mobileZoom,
    model,
    showLegend,
  });

  return {
    canvasRect: desktopZoom.canvasRect,
    canvasRef,
    isLoading: canvasRendering.isLoading,
    isZoomVisible: desktopZoom.isZoomVisible,
    labelColourMap: canvasRendering.labelColourMap,
    mobileZoom: touchHandlers.mobileZoom,
    mousePosition: desktopZoom.mousePosition,
    visibleAnnotations: canvasRendering.visibleAnnotations,
  };
};
